import { Button, Dialog, DialogButtons, Modal, Spinner } from '@st/theme'
import { match } from '@st/pattern'
import { useProcess, useSelect } from '~/store'
import { selOrganizationIntegrations } from './organization-integrations-module'
import { OrganizationSettingsScaffold } from './st-organization-settings-scaffold'
import { useOrganizationRole } from './use-organization-role'

export function OrganizationIntegrationsPage() {
  const model = useSelect('organizationIntegrations', selOrganizationIntegrations)
  const { send } = useProcess('organizationIntegrations')
  const role = useOrganizationRole()

  return (
    <OrganizationSettingsScaffold title="Settings">
      <h2 className="mb-5 text-xl text-gray-800">Integrations</h2>

      {match(model)
        .with({ status: 'loading' }, () => <Spinner />)
        .with({ status: 'none' }, () => (
          <p className="text-base text-gray-600">No integrations connected.</p>
        ))
        .with({ status: 'connected' }, (model) => (
          <div className="flex max-w-2xl items-center justify-between rounded-lg border border-gray-200 bg-white p-5">
            <div className="flex items-center gap-4">
              <img src="/logos/proconnect.png" alt="ProConnect" className="size-10 rounded-md" />
              <div>
                <h3 className="text-base font-semibold text-gray-900">ProConnect</h3>
                <p className="text-sm text-gray-600">
                  Connected to account {model.externalAccountId}
                </p>
              </div>
            </div>

            {role == 'owner' && (
              <Button
                variant="default"
                disabled={model.disconnecting}
                onClick={() => send({ type: 'disconnectClicked' })}
              >
                {model.disconnecting ? 'Disconnecting…' : 'Disconnect'}
              </Button>
            )}
          </div>
        ))
        .exhaustive()}

      <Modal isOpen={model.status == 'connected' && model.confirmingDisconnect}>
        <Dialog
          title="Disconnect ProConnect?"
          subtitle="StanfordTax will no longer be able to import returns from this ProConnect account."
          buttons={
            <DialogButtons>
              <Button variant="default" onClick={() => send({ type: 'disconnectCancelled' })}>
                Cancel
              </Button>
              <Button variant="primary" onClick={() => send({ type: 'disconnectRequested' })}>
                Disconnect
              </Button>
            </DialogButtons>
          }
        />
      </Modal>
    </OrganizationSettingsScaffold>
  )
}
